import styled from "styled-components"

import { useDispatch, useSelector } from "react-redux"
import { handleCustomizer, notificationDropdown, topbarDropdown } from "../../../../features/layout/layoutSlice"
import TopbarDropdown from "./TopbarUserDropdown"
import UserRoleDropdown from "./TopbarRoleDropdown"
import TopbarThemeDropdown from "./TopbarThemeDropdown"
import TopbarNotification from "./TopbarNotification"
import MessageSvg from "../../../icons/top/MessageSvg"
import { Link } from "react-router-dom"
import { IoSettingsOutline, IoNotificationsOutline } from "react-icons/io5";
import logo from "../../../../images/img/default-logo.jpg"
import { useEffect, useState } from "react"

const Container = styled.div`
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;
        cursor: pointer;
        z-index: 20;
        width: ${({garageStatsState}) => garageStatsState === "open" ? "20%" : "90%"};
        justify-content: flex-end;

          .logo-box{
            width: 150px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img{
              width: 100%;
              height: 50px;
              object-fit: contain;
            }
          }
          .avatar{
            img{
              width: 30px;
              height: 30px;
            }
          }
        .user-info{
          display: flex;
          flex-direction: column;
          margin-right: 10px;
          color: ${({ theme }) => theme.mainTextColor};

          .company-name {
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            line-height: 19px;
          }

          .username{
            font-size: 16px;
            font-weight: var(--font-weight-sm);
            line-height: 19px;
            margin-top: 3px;
          }
        }

        .notification-wrapper{
            display: flex;
            align-items: center;
            gap: 20px;
            justify-content: center;
            padding: 5px 10px;
            border-radius: 10px;
            border: 1px solid #c9c5c5;

            img{
              width: 30px;
              height: 30px;
            }
            .notification-container{
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              .notification-count{
                position: absolute;
                top: -5px;
                right: -5px;
                background-color: var(--color-main);
                color: white;
                font-size: 12px;
                padding: 2px 5px;
                border-radius: 50%;
                
              }
            }
        }

        .message-link{
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .settings-icon{
          font-size: 1.6rem;
        }
`
const TopbarTopUser = () => {
  const dispatch = useDispatch()
  const {showTopbarDropdown, theme, showUserRoleDropdown, showThemeDropdown, showNotificationDropdown, garageStatsState}= useSelector((state)=> state.layout)
  const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)
  const {notificationList} = useSelector((state)=> state.notification)

  const [notificationCount, setNotificationCount] = useState(0)

  useEffect(() => {
    setNotificationCount(notificationList.filter(item => item.isRead === false).length)
  },[notificationList])

  return (
    <Container garageStatsState={garageStatsState}>
        
        <div onClick={()=> dispatch(topbarDropdown())} className="logo-box">
          <img src={topBarCompanyInfo?.logo1 ? `${process.env.REACT_APP_API_IMG_COMPANY_URI}${topBarCompanyInfo.logo1}` : topBarCompanyInfo?.logo2 ? `${process.env.REACT_APP_API_IMG_COMPANY_URI}${topBarCompanyInfo.logo2}` : logo} alt="logo" />
        </div>
        <div className="notification-wrapper">
          <Link to={"/mesajlar"} className="message-link">
            <MessageSvg />
          </Link>
          <div className="notification-container">
            {notificationCount > 0 && <div className="notification-count">{notificationCount}</div>}
            <IoNotificationsOutline className={"settings-icon"} onClick={() => dispatch(notificationDropdown())}/>
          </div>
          <IoSettingsOutline className={"settings-icon"} onClick={() => dispatch(handleCustomizer(true))}/>
        </div>

        {
          showNotificationDropdown && <TopbarNotification />
        }
         
        { 
          showTopbarDropdown && <TopbarDropdown/>
        }
        {
          showUserRoleDropdown && <UserRoleDropdown/>
        }
        {
          showThemeDropdown && <TopbarThemeDropdown/>
        }
    </Container>
  )
}

export default TopbarTopUser